// The Array.prototype.entries provided by Prototype.js is implemented incorrectly
// and breaks the ArrayIterator polyfill provided by core-js
// Remove it so it can be replaced by a spec compliant version.
delete Array.prototype.entries;
